import { render, staticRenderFns } from "./ProductParametersGrouped.vue?vue&type=template&id=909ddfd6&"
import script from "./ProductParametersGrouped.vue?vue&type=script&lang=js&"
export * from "./ProductParametersGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports